module.exports = __webpack_public_path__ + "static/media/subscript.4a5c27ec.svg";